export class stringUtility{
    mergeStringContainFromArray(arrData,searchString,replaceName){
        let stringContaininArr = arrData.filter(x=> {
            if (x.levelTitle.toLowerCase().includes(searchString)) return x;
        })
        
        if(stringContaininArr.length > 0){
            for(let i=0;i<stringContaininArr.length;i++){
                let index = arrData.findIndex(x=>x.levelId == stringContaininArr[i]['levelId'])
                if(index > -1){
                    arrData.splice(index, 1);
                }
            }
            let lengthContaininArr = stringContaininArr.length;
            arrData.push({
                levelId: stringContaininArr[lengthContaininArr-1]['levelId'],
                levelTitle: replaceName,
                levelShortTitle: stringContaininArr[lengthContaininArr-1]['levelShortTitle']
            });
        }
        return arrData;
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/utils/stringUtility.js
// module id = null
// module chunks = 